import { Injectable } from '@angular/core';
import { Logger } from 'src/app/core/logger';

const logger =  new Logger('UtilsService');

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

copyToClipboard(text: string, contentType = 'text/plain', callback?: Function): void {
    const hasClipboard = typeof navigator !== 'undefined' && !!navigator.clipboard;
    const hasWrite = hasClipboard && typeof navigator.clipboard.write === 'function';
    const hasWriteText = hasClipboard && typeof navigator.clipboard.writeText === 'function';
    const hasClipboardItem = typeof (window as any).ClipboardItem !== 'undefined';
    const isCallbackFunction = typeof callback === 'function';

    const callCallback = () => {
        if (isCallbackFunction) callback!();
    };

    if (contentType === 'text/html' && hasWrite && hasClipboardItem) {
      const htmlBlob = new Blob([text], { type: 'text/html' });
      const plainTextBlob = new Blob([text], { type: 'text/plain' });
      const item = new (window as any).ClipboardItem({
        'text/html': htmlBlob,
        'text/plain': plainTextBlob
      });
      navigator.clipboard.write([item])
        .then(() => {
          callCallback();
        })
        .catch(err => {
          logger.error('Failed to copy HTML using Clipboard API:', err);
          if (hasWriteText) {
            navigator.clipboard.writeText(text)
              .then(() => callCallback())
              .catch(() => this.execCommandCopy(text, callback));
          } else {
            this.execCommandCopy(text, callback);
          }
        });
    } else if (hasWriteText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          callCallback();
        })
        .catch(err => {
          logger.error('Failed to copy text using Clipboard API:', err);
          this.execCommandCopy(text, callback);
        });
    } else {
      this.execCommandCopy(text, callback);
    }
  }

  private execCommandCopy(text: string, callback?: Function): void {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-999999px';
      textarea.style.top = '-999999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textarea);

      if (successful && callback && typeof callback === 'function') {
        callback();
      }
    } catch (err) {
      logger.error('Failed to copy text using execCommand:', err);
    }
  }
}
